import { RfxTab } from "newui/features/Rfx/types/component-types";
import { BasePaths } from "./navigation.types";

export class GuestPaths extends BasePaths {
	constructor() {
		super("/account/");
		this.home = this.prefixWithBasePath("rfx");
	}

	/**
	 *
	 * @param rfxId The id of the RFx invite being viewed
	 * @param tabId Optional id of the tab to navigate to
	 * @param contextId Optional id for the tab context
	 * @returns Full Url for viewing a given RFx
	 */
	viewRfxSubmission(
		rfxId: number,
		tabId: RfxTab | null = null,
		contextId: number | string | null = null
	) {
		const basePath = this.prefixWithBasePath(`rfx/${rfxId}/submission`);

		if (!tabId) {
			return basePath;
		}

		return `${basePath}/${tabId}/${contextId ? contextId : ""}`;
	}
}
